<template>
  <div class="toggle-input">
    <label class="toggle-wrapper">
      <div class="toggle">
        <input v-model="checked" type="checkbox" />
        <span class="toggler"></span>
      </div>
      <span v-if="props.label" class="text-bold text-m">
        {{ props.label }}
      </span>
    </label>

    <ErrorMessage :has-error="hasError" :error-message="errorMessage" :is-warning="true" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import ErrorMessage from './ErrorMessage.vue'

const modelValue = defineModel({ type: [Boolean] })
const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  errorMessage: {
    type: String,
    default: ''
  },
  hasError: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const checked = computed({
  get: () => modelValue.value,
  set: (value) => emit('update:modelValue', value)
})
</script>

<style scoped>
.toggle-input {
  --gap: 1rem;
  --toggle-height: 24px;
  --toggle-gap: 2px;

  display: flex;
  flex-direction: column;
  gap: var(--gap);
  margin: var(--gap);
}

.toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.toggle {
  position: relative;
  display: inline-block;
  width: 48px;
  height: var(--toggle-height);
}

/* Hide default HTML checkbox */
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggler {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: var(--neutral-60);
  transition: var(--time2);
  border-radius: var(--toggle-height);
}

.toggler::before {
  position: absolute;
  content: '';
  height: calc(var(--toggle-height) - var(--toggle-gap) * 2);
  width: calc(var(--toggle-height) - var(--toggle-gap) * 2);
  left: var(--toggle-gap);
  bottom: var(--toggle-gap);
  background-color: var(--white);
  transition: var(--time2);
  border-radius: 50%;
}

input:checked + .toggler {
  background-color: var(--success);
}

input:focus + .toggler {
  box-shadow: 0 0 1px var(--success);
}

input:checked + .toggler::before {
  transform: translateX(var(--toggle-height));
}
</style>
